import * as yup from 'yup';

import i18n from 'i18n/config';
import { checkForDateInFuture, checkIfDateEndsAfterStart, checkIfDateIsAtLeastFiveMinutesInFuture } from 'utils/utils';

import { getCreateNewRoomSchema } from './getCreateNewRoom';

type CreateNewRoomFields = yup.InferType<ReturnType<typeof getCreateNewRoomSchema>>;

export const getScheduleDateValidationTest = () => ({
  name: 'schedule-date-validation',
  test({ startDate, startTime, endDate, endTime, timeZone }: CreateNewRoomFields, { createError }: yup.TestContext) {
    if (!startDate || !startTime) return true;

    const startDateProps = { startDate, startTime, timeZone };

    const isStartDateInFuture = checkForDateInFuture(startDateProps);
    const isAtLeastFiveMinInFuture = checkIfDateIsAtLeastFiveMinutesInFuture(startDateProps);

    if (!isStartDateInFuture || !isAtLeastFiveMinInFuture) {
      const message = !isStartDateInFuture ? i18n.t('future_date_error') : i18n.t('start_at_least_five_minutes');
      return createError({ path: 'startDate', message });
    }

    if (!endDate || !endTime) return true;

    const isEndAfterStart = checkIfDateEndsAfterStart({ startDate, startTime, endDate, endTime });
    if (!isEndAfterStart) return createError({ path: 'endDate', message: i18n.t('meeting_can_not_end_before_start') });

    return true;
  },
});
